import { render } from "./RtcmMessagesFiltersAddRenameModal.vue?vue&type=template&id=0f4c5cd6"
import script from "./RtcmMessagesFiltersAddRenameModal.vue?vue&type=script&lang=js"
export * from "./RtcmMessagesFiltersAddRenameModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__